import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHome: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHome"><Path fillRule="evenodd" clipRule="evenodd" d="M12 1.28094L21 8.64458V21H3V8.64458L12 1.28094Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHome;
